import { envs } from '@config/envs'
import { IConfig, UnleashClient } from 'unleash-proxy-client'

const UNLEASH_CONFIG = {
  url: envs.unleashUri,
  clientKey: envs.unleashClientKey,
  refreshInterval: Number(envs.unleashRefreshInterval),
  appName: envs.unleashAppName,
} as IConfig

export const unleashClient = new UnleashClient(UNLEASH_CONFIG)
